import React from 'react';
export function BonusesSection() {
  const bonuses = [{
    num: '01',
    title: 'The 7-Day Attack Plan',
    desc: 'The roadmap to implement the system and organize your entire club in one week.',
    val: '$80'
  }, {
    num: '02',
    title: 'The Clear Cue Bank',
    desc: '40 high-impact analogies to explain the most complex strokes effortlessly.',
    val: '$100'
  }, {
    num: '03',
    title: 'Activation Kit',
    desc: "30 mental-game prompts to capture your group's attention in the first 5 minutes.",
    val: '$70'
  }, {
    num: '04',
    title: 'Rainy Day Classroom',
    desc: '25 tactical lessons to teach indoors so you never lose a paid hour to the weather again.',
    val: '$60'
  }, {
    num: '05',
    title: 'Large Group Matrix',
    desc: 'Elite rotation strategies to keep 8+ players active on one court without a "waiting line."',
    val: '$90'
  }, {
    num: '06',
    title: 'The 52-Week Junior Pathway',
    desc: 'The full year of organized progressions for your junior academy (Red to Green ball).',
    val: '$50'
  }];
  return <section className="bg-brand-dark py-24 px-4 border-t border-brand-border pt-[40px] pb-[40px]" data-id="element-15">
      <div className="max-w-5xl mx-auto" data-id="element-16">
        <div className="text-center mb-16" data-id="element-17">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-4" data-id="element-18">
            🎁 Exclusive{' '}
            <span className="text-brand-accent" data-id="element-19">
              Strategic Bonuses Included
            </span>
          </h2>
          <p className="text-lg text-white/70 font-medium" data-id="element-20">
            Only when purchasing today, you will receive at no extra cost:
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mb-16" data-id="element-21">
          {bonuses.map((bonus, i) => <div key={i} className="bg-brand-card rounded-2xl p-6 border border-brand-border relative overflow-hidden" data-id="element-22">
              <div className="text-6xl font-heading font-black text-brand-accent/20 absolute top-3 right-4 leading-none" aria-hidden="true" data-id="element-23">
                {bonus.num}
              </div>
              <div className="relative z-10" data-id="element-24">
                <div className="text-brand-accent font-badge font-black text-sm tracking-widest uppercase mb-4" data-id="element-25">
                  BONUS #{bonus.num}
                </div>
                <h3 className="text-xl font-heading font-bold text-white mb-3 pr-10 leading-tight" data-id="element-26">
                  {bonus.title}
                </h3>
                <p className="text-white/70 mb-6 text-sm leading-relaxed" data-id="element-27">
                  {bonus.desc}
                </p>
                <div className="flex items-center justify-between pt-4 border-t border-brand-border" data-id="element-28">
                  <div className="text-white/60 line-through text-sm" data-id="element-29">
                    Value {bonus.val}
                  </div>
                  <div className="text-brand-dark font-black text-sm bg-brand-accent px-4 py-1 rounded-full uppercase tracking-wider" data-id="element-30">
                    FREE
                  </div>
                </div>
              </div>
            </div>)}
        </div>
        <div className="bg-brand-accent/5 rounded-2xl p-8 text-center border border-brand-accent/20 max-w-2xl mx-auto" data-id="element-31">
          <h3 className="text-xl font-heading font-bold text-brand-accent mb-2" data-id="element-32">
            🎁 FREE BONUSES — Limited time only
          </h3>
          <p className="text-white/70 font-medium" data-id="element-33">
            Included in every offer. Always.
          </p>
        </div>
      </div>
    </section>;
}